import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

import { WatermarkConfigDetails } from '../../../../../../../graphql/fragments/account';

export const getWatermarkSettingsQuery = gql`
  query getWatermarkSettings($id: RecordID!) {
    hierarchyItem(id: $id) {
      ... on HierarchyAlbumItem {
        id
        album {
          id
          root_album_folder {
            id
          }
          creator {
            id
            pro_settings {
              ...WatermarkConfigDetails
            }
          }
        }
      }
      ... on HierarchyAlbumFolderItem {
        id
        album_folder {
          id
          root {
            id
          }
          creator: account {
            id
            pro_settings {
              ...WatermarkConfigDetails
            }
          }
        }
      }
    }
  }
  ${WatermarkConfigDetails}
`;

const getWatermarkSettings = graphql(getWatermarkSettingsQuery);

export default getWatermarkSettings;
